// Media Queries
export const phoneOnlyMaxWidth = '599px';
export const tabletPortraitMinWidth = '600px';
export const tabletPortraitMaxWidth = '1099px';
export const tabletLandscapeMinWidth = '1100px';
export const tabletLandscapeMaxWidth = '1399px';
export const desktopMinWidth = '1400px';
export const singleColumnMaxWidth = '800px';
export const simpleViewMaxWidth = '600px';

export const phoneOnlyMaxScreenWidth = 599;
export const isPhoneScreen = (screenWidth: number) => screenWidth <= phoneOnlyMaxScreenWidth;
export const tabletPortraitMinScreenWidth = 600;

// Dimensions
export const appHeaderHeight = '107px'; // 30px logo height + padding(62+15)
export const appFooterHeight = '102px'; // text height(28+14) + text margin(20*2) + outer padding(5+15).
export const dashboardHeaderHeightV2 = '160px';
export const appFooterV2Height = '200px';
export const bottomNavBarHeight = '84px';
export const bottomNavBarV2Height = '104px';
export const headerIconPadding = '12px';
export const contentPadding = '10px';
export const newContentPadding = '16px';
export const cardButtonBottomPadding = '32px';
export const cardInnerGap = '12px'; // Default gap between elements in card, can be overridden by specific card types if needed
export const cardLargeInnerGap = '16px'; // Larger gap for cards with more content, such as content cards with images
export const sectionPadding = '18px'; // TODO: Rename to sectionMarginGap
export const tabletLandscapePadding = '60px';
export const tilePadding = '15px';
export const fieldHeight = '52px';
export const newFieldHeight = '50px';
export const pageContentMaxWidth = '1135px';
export const singleColumnPageContentMaxWidth = '599px';
export const oneIconCellWidth = '42px'; // td padding-left(12px) + icon width(30px)
export const twoIconsCellWidth = (screenWidth: number) => (isPhoneScreen(screenWidth) ? oneIconCellWidth : '83px');
export const threeIconsCellWidth = (screenWidth: number) => (isPhoneScreen(screenWidth) ? oneIconCellWidth : '118px');
export const dateCellWidth = '120px';
export const frequencyCellWidth = '90px';
export const numberCellWidth = '140px';
export const eventEditProfileIconSize = '14px';
export const chatInputHeight = '54px';

export const phoneStatusBarHeight = '58px';
export const appHeaderWrapperHeightV2 = '103px'; // header height(40px) + padding-top/phoneStatusBarHeight(58px) + padding-bottom(5px)
export const appHeaderProgressLineHeight = '2px';
export const appHeaderGap = '18px';
export const tabMenuHeight = '45px';
export const tabMenuWithPaddingHeight = '81px'; // tabMenu height(45px) + padding-top(18px) + padding-bottom(18px)
export const contentTopGapWithTabMenu = '63px'; // tabMenuHeight - appHeaderGap
export const cardBorderRadius = '12px';

// Colours
export const whiteColour = '#FFFFFF';
export const whiteBackground = '#F9FAFB';
export const greyBackground = '#F3F4F6';
export const greyWhite = '#F8F9FC';
export const transparent = 'transparent';
export const brandingColourHeavy = '#005E9E';
export const brandingColourHeavyLight = 'rgba(0, 94, 158, 0.8)';
export const brandingColourLight = '#C2D7E7';
export const brandingColourLightV2 = '#008AEC';
export const borderGrey = '#D2D6DC';
export const labelGrey = 'rgba(108, 108, 108, 0.8)';
export const textGrey = 'rgba(108, 108, 108, 1)'; // #6C6C6C
export const slateGrey = '#4b5563';
export const darkerSlateGrey = '#1f2937';
export const darkTextColour = '#3C3C3C';
export const darkColour = '#1E232B';
export const darkBlack = '#464B51';
export const blackColour = '#000000';
export const greyColour = '#374151';
export const lightGreyColour = '#666666';
export const darkGreyColour = '#4B4B4B';
export const superLightGreyColour = '#6B7280';
export const newBorderGrey = '#ADAFB1';
export const borderLightGrey = '#E2E8F0';
export const lightGrayish = '#F1F5F9';
export const boxShadow = `0px 4px 16px 2px ${lightGrayish}`;
export const cardBorder = `1px solid ${borderLightGrey}`;
export const cardGreyBackground = '#E5E7EB';
export const separatorLineGrey = '#D1D5DB';
export const darkGreyMedium = 'rgba(85, 85, 85, 0.70)';
export const lightGrayishBlue = '#E5EFF5';

export const activeBlueColour = '#008AEC';
export const errorRed = '#CC3300';
export const newErrorRed = '#F25656';
export const warningYellow = '#FAAA00';
export const warningYellow2 = '#FDA700';
export const okGreen = '#019A6B';
export const okGreen2 = '#006F4D';
export const purple = '#842FA4';
export const darkPurple = '#332272';
export const lightPurple = '#E6E6FA';
export const lightYellow = '#FFF4BD';
export const lightMint = '#CBE4D9';

export const labelRedColour = '#C30';
export const labelOrangeColour = '#FDA700';
export const labelBlueColour = brandingColourHeavy;
export const labelGreyColour = '#9CA3AF';
export const badgeColorGreen = `#21B658`;

// zIndex
export const aboveCommonElementsZIndex = 1;
export const bodyFixedElementsZIndex = aboveCommonElementsZIndex + 1;
export const globalHeaderZIndex = 999;
export const screenBottomNavZIndex = globalHeaderZIndex - 1;
export const popupZIndex = globalHeaderZIndex + 1;
export const loadingZIndex = popupZIndex + 1;

// guided tour
export const guidedTourToolTipTitleAndContentSize = '12px';
export const guidedTourToolTipButtonSize = '11px';
export const guidedTourToolTipTitleAndContentColor = '#374151';
export const guidedTourToolTipButtonColor = '#111827';
